import { Reveal } from "./Reveal";

const chapters = [
    {
        num: "01",
        title: "Why we exist",
        body: "Insurance in India is too often sold, not explained. Fine print hides exclusions, and families in Coimbatore discover gaps only at claim time. PolicyOne exists to flip that — advice first, policy second.",
        span: "lg:col-span-7",
    },
    {
        num: "02",
        title: "How we work",
        body: "We are not tied to any single insurer. We compare term plans, health covers and motor policies across 40+ companies, then recommend the one that fits your life and budget — not our commission.",
        span: "lg:col-span-5 lg:mt-32",
    },
    {
        num: "03",
        title: "What it costs you",
        body: "Nothing. Insurers pay us a regulated commission, so our advice, comparisons and claim assistance are free for you — for the entire life of your policy, not just at purchase.",
        span: "lg:col-span-6 lg:col-start-4",
    },
];

export const Manifesto = () => (
    <section id="manifesto" data-testid="manifesto-section" className="mx-auto max-w-7xl px-6 py-32 md:px-12 md:py-40">
        <Reveal>
            <p className="mb-20 font-mono text-xs uppercase tracking-[0.25em] text-clay" data-testid="manifesto-overline">
                The PolicyOne Manifesto
            </p>
        </Reveal>
        <div className="grid grid-cols-1 gap-20 lg:grid-cols-12 lg:gap-8">
            {chapters.map((c, i) => (
                <Reveal key={c.num} delay={i * 0.1} className={c.span}>
                    <div data-testid={`manifesto-chapter-${c.num}`} className="border-t border-line pt-8">
                        <span className="font-serif text-7xl font-light text-clay md:text-8xl">{c.num}</span>
                        <h3 className="mt-6 font-serif text-2xl font-medium md:text-3xl">{c.title}</h3>
                        <p className="mt-5 max-w-lg text-base leading-relaxed text-moss md:text-lg">{c.body}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
